// KDS design-token → semantic role: key is the var the bridge emits for the
// token (`--kds-<group>-<token>`), value is the --if-* role in tokens.css.
// Unmapped tokens keep their literal colour in every theme.
const KDS_TOKEN_MAP = {
  '--kds-base-snow-white': '--if-surface-1',
  '--kds-base-full-moon': '--if-surface-2',
  '--kds-base-half-moon': '--if-surface-3',
  '--kds-base-quarter-moon': '--if-border-strong',
  '--kds-base-alaskan-husky': '--if-ink-2',
  '--kds-base-black-sheep': '--if-code-bg',
  '--kds-base-midnight': '--if-nav-bg',
  '--kds-base-charcoal': '--if-ink-1',

  '--kds-opacity-full-moon-50': '--if-surface-2-50',
  '--kds-opacity-midnight-50': '--if-nav-bg-50',
  '--kds-opacity-charcoal-15': '--if-border',
  '--kds-opacity-charcoal-40': '--if-ink-disabled',
  '--kds-opacity-charcoal-75': '--if-overlay',

  '--kds-interaction-pacific-ocean': '--if-accent',
  '--kds-interaction-pacific-ocean-15': '--if-accent-soft',
  '--kds-interaction-pacific-ocean-40': '--if-focus',
  '--kds-interaction-indian-ocean': '--if-accent-hover',

  '--kds-status-information-light': '--if-info-soft',
  '--kds-status-information-medium': '--if-info',
  '--kds-status-information-dark': '--if-info-ink',
  '--kds-status-success-light': '--if-success-soft',
  '--kds-status-success-medium': '--if-success',
  '--kds-status-success-dark': '--if-success-ink',
  '--kds-status-warning-light': '--if-warning-soft',
  '--kds-status-warning-medium': '--if-warning',
  '--kds-status-warning-dark': '--if-warning-ink',
  '--kds-status-danger-light': '--if-danger-soft',
  '--kds-status-danger-medium': '--if-danger',
  '--kds-status-danger-dark': '--if-danger-ink',

  '--kds-shadow-light-default': '--if-shadow',
  '--kds-shadow-dark-default': '--if-shadow',

  '--kds-visual-interest-licorice-mousse-light': '--if-neutral-soft',
  '--kds-visual-interest-licorice-mousse-medium': '--if-neutral-ink',
  '--kds-visual-interest-licorice-mousse-dark': '--if-neutral-strong',
};

export default KDS_TOKEN_MAP;
